// Utility per compressione immagini
// Ridimensiona a max 1024px larghezza, qualità JPEG 65%

export const compressImage = (file, maxWidth = 1024, quality = 0.65) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      const img = new Image();
      
      img.onload = () => {
        // Calcola nuove dimensioni mantenendo aspect ratio
        let width = img.width;
        let height = img.height;
        
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
        
        // Crea canvas per ridimensionamento
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // Converti in JPEG compresso
        canvas.toBlob(
          (blob) => {
            if (blob) {
              // Converti blob in base64
              const reader2 = new FileReader();
              reader2.onloadend = () => {
                const base64 = reader2.result;
                const sizeKB = Math.round(blob.size / 1024);
                console.log(`Image compressed: ${sizeKB}KB (${width}x${height})`);
                resolve({
                  base64,
                  sizeKB,
                  width,
                  height
                });
              };
              reader2.readAsDataURL(blob);
            } else {
              reject(new Error('Compressione fallita'));
            }
          },
          'image/jpeg',
          quality
        );
      };
      
      img.onerror = () => reject(new Error('Errore caricamento immagine'));
      img.src = event.target.result;
    };
    
    reader.onerror = () => reject(new Error('Errore lettura file'));
    reader.readAsDataURL(file);
  });
};

export default compressImage;
